import React, { useState, useEffect } from "react";
import "../../styles/FolderWindow.css";
import { fetchMusicFiles } from "../FirebaseUtils";
import AudioPlayer from "../Player/AudioPlayer";
import backButton from "../../assets/images/back.png";
import closeButton from "../../assets/images/close.png";

const MusicWindow = ({ folderPath, embedContent, onClose }) => {
  const [contents, setContents] = useState({ folders: [], files: [] });
  const [audioSrc, setAudioSrc] = useState(null);
  const [audioPath, setAudioPath] = useState(null);
  const [currentPath, setCurrentPath] = useState(folderPath);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!embedContent) {
      const fetchContents = async () => {
        setIsLoading(true);
        try {
          const data = await fetchMusicFiles(currentPath);
          setContents(data);
        } catch (error) {
          console.error("Error fetching music files:", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchContents();
    }
  }, [currentPath, embedContent]);

  const handleOpenSubfolder = (subfolderPath) => {
    setCurrentPath(subfolderPath);
  };

  const handleBack = () => {
    const parentPath = currentPath.substring(0, currentPath.lastIndexOf("/"));
    setCurrentPath(parentPath || "");
  };

  const handleFileClick = (file) => {
    const extension = file.name.split(".").pop().toLowerCase();
    if (["mp3", "wav"].includes(extension)) {
      setAudioSrc(file.url);
      setAudioPath(file.path);
    }
    else {
      // Ouvrir tout autre fichier dans un nouvel onglet
      window.open(file.url, "_blank");
    }
  };

  return (
    <div className="folder-window">
      {/* Header */}
      <div className="folder-header">
        <span>{embedContent ? "Streaming" : currentPath || "MUSIC"}</span>
        <button
          onClick={onClose}
          style={{ background: "none", border: "none", cursor: "pointer" }}
        >
          <img src={closeButton} alt="Close" style={{ width: "24px", height: "auto" }} />
        </button>
      </div>

      {/* Contenu */}
      <div className="folder-content">
        {embedContent ? (
          <div dangerouslySetInnerHTML={{ __html: embedContent }} />
        ) : isLoading ? (
          <div className="loading-spinner">Loading...</div>
        ) : (
          <>
            {currentPath && currentPath !== "" && (
              <button onClick={handleBack} style={{ border: "none", background: "none" }}>
                <img src={backButton} alt="Back" style={{ width: "24px", height: "auto" }} />
              </button>
            )}

            <div className="folder-section">
              <h3>Folders:</h3>
              <ul>
                {contents.folders.map((folder, index) => (
                  <li
                    key={index}
                    onClick={() => handleOpenSubfolder(folder.path)}
                    style={{ cursor: "pointer" }}
                  >
                    <span role="img" aria-label="folder">
                      📁
                    </span>{" "}
                    {folder.name}
                  </li>
                ))}
              </ul>
            </div>

            <div className="file-section">
              <h3>Files:</h3>
              <ul>
                {contents.files.map((file, index) => (
                  <li key={index} onClick={() => handleFileClick(file)}>
                    <span role="img" aria-label="file">
                      📄
                    </span>{" "}
                    {file.name}
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>

      {/* Lecteur Audio */}
      {audioSrc && (
        <AudioPlayer
          audioSrc={audioSrc}
          audioPath={audioPath}
          onClose={() => {
            setAudioSrc(null);
            setAudioPath(null);
          }}
        />
      )}
    </div>
  );
};

export default MusicWindow;